<ng-template #strategiesInfo>
  <div class="strategies-info upload-client h-100 d-flex flex-column">
    <div class="d-flex mb-3 h-100" cdkDropListGroup>
      <div class="strategies-list d-flex flex-column">
        <div class="d-flex header-col">
          <div class="bold heading pointer" [ngClass]="{'selected-tab' : currentTab === 'AI Strategies'}" (click)="selectTab('AI Strategies')">AI Suggested Strategies</div>
          <div class="bold heading pointer" [ngClass]="{'selected-tab' : currentTab === 'All Strategies'}" (click)="selectTab('All Strategies')">All Strategies</div>
        </div>
        <div class="d-flex align-items-center filter-row-anchor">
          <input style="margin: 0.5rem; flex: 1;" type="text" [(ngModel)]="searchKey" placeholder="Search strategy" (keyup)="onSearchChange()" aria-label="Search strategy"/>
          <button *ngIf="hasAnyFilterAvailable()" type="button" (click)="toggleFilters()" class="filter-btn" style="margin: 0.5rem 0.5rem 0.5rem 0; white-space: nowrap;"
                  [attr.aria-pressed]="hasActiveFilters()"
                  [attr.aria-expanded]="showFilters"
                  aria-haspopup="dialog"
                  [style.border-color]="hasActiveFilters() ? '#1570EF' : '#D0D5DD'"
                  [style.color]="hasActiveFilters() ? '#1570EF' : 'inherit'">
            <img src="../../../../images/tpiq-icons/SVG/filter.svg" alt="" aria-hidden="true" style="margin-right: 4px;"> Filters
            <span *ngIf="hasActiveFilters()" aria-hidden="true" style="background:#1570EF;color:#fff;border-radius:10px;font-size:10px;padding:1px 6px;margin-left:4px;">&#9679;</span>
          </button>

          <div *ngIf="showFilters" class="filter-backdrop" (click)="showFilters = false"></div>
          <div *ngIf="showFilters" class="filter-dropdown"
               role="dialog" aria-modal="true" aria-labelledby="tax-strategy-filters-title">
            <div style="height: 50px; padding: 15px; color: #333333;">
              <span id="tax-strategy-filters-title" class="float-left" style="font-weight: 600;">Filters</span>
              <button type="button" (click)="showFilters = false" class="float-right pointer" aria-label="Close filters"
                      style="background: none; border: none; padding: 0; font: inherit; cursor: pointer;">&#x2715;</button>
            </div>
            <div style="padding: 0 15px;"><hr style="margin: 0;"/></div>
            <div class="body">
              <div class="row row-padding-reveal">

                <div class="small-12 medium-6 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.category">
                  <label class="label-name label-top">
                    Category
                    <span *ngIf="!filterAvailability.category" class="filter-empty-hint">(no data)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.category ? 'No strategies in this firm have this field populated' : null">
                    <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                      <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'category')">
                        <span class="multi-select-placeholder">Category</span>
                        <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('category')">arrow_drop_down</i>
                      </div>
                      <div *ngIf="isMultiSelectOpen('category')" class="multi-select-menu">
                        <div class="multi-select-menu-title">Select one or more</div>
                        <label *ngFor="let option of categoryOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                          <input type="checkbox" [checked]="isOptionSelected('category', option)"
                                 (change)="onMultiSelectOptionChange('category', option, $event)">
                          <span>{{ getOptionLabel(option) }}</span>
                        </label>
                      </div>
                      <div *ngIf="getSelectedOptions('category').length" class="selected-filter-chips">
                        <span *ngFor="let selected of getSelectedOptions('category'); trackBy: trackByFilterValue" class="selected-filter-chip">
                          <span>{{ selected.label }}</span>
                          <button type="button" class="selected-filter-chip-remove" (click)="removeMultiSelectValue('category', selected.value, $event)" aria-label="Remove {{ selected.label }} from category filter">
                            <i class="icon ion-close-round" aria-hidden="true"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="small-12 medium-6 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.complexity">
                  <label class="label-name label-top">
                    Complexity
                    <span *ngIf="!filterAvailability.complexity" class="filter-empty-hint">(no data)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.complexity ? 'No strategies in this firm have this field populated' : null">
                    <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                      <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'complexity')">
                        <span class="multi-select-placeholder">Complexity</span>
                        <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('complexity')">arrow_drop_down</i>
                      </div>
                      <div *ngIf="isMultiSelectOpen('complexity')" class="multi-select-menu">
                        <div class="multi-select-menu-title">Select one or more</div>
                        <label *ngFor="let option of complexityOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                          <input type="checkbox" [checked]="isOptionSelected('complexity', option)"
                                 (change)="onMultiSelectOptionChange('complexity', option, $event)">
                          <span>{{ getOptionLabel(option) }}</span>
                        </label>
                      </div>
                      <div *ngIf="getSelectedOptions('complexity').length" class="selected-filter-chips">
                        <span *ngFor="let selected of getSelectedOptions('complexity'); trackBy: trackByFilterValue" class="selected-filter-chip">
                          <span>{{ selected.label }}</span>
                          <button type="button" class="selected-filter-chip-remove" (click)="removeMultiSelectValue('complexity', selected.value, $event)" aria-label="Remove {{ selected.label }} from complexity filter">
                            <i class="icon ion-close-round" aria-hidden="true"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="small-12 medium-6 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.urgency">
                  <label class="label-name label-top">
                    Urgency
                    <span *ngIf="!filterAvailability.urgency" class="filter-empty-hint">(no data)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.urgency ? 'No strategies in this firm have this field populated' : null">
                    <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                      <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'urgency')">
                        <span class="multi-select-placeholder">Urgency</span>
                        <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('urgency')">arrow_drop_down</i>
                      </div>
                      <div *ngIf="isMultiSelectOpen('urgency')" class="multi-select-menu">
                        <div class="multi-select-menu-title">Select one or more</div>
                        <label *ngFor="let option of urgencyOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                          <input type="checkbox" [checked]="isOptionSelected('urgency', option)"
                                 (change)="onMultiSelectOptionChange('urgency', option, $event)">
                          <span>{{ getOptionLabel(option) }}</span>
                        </label>
                      </div>
                      <div *ngIf="getSelectedOptions('urgency').length" class="selected-filter-chips">
                        <span *ngFor="let selected of getSelectedOptions('urgency'); trackBy: trackByFilterValue" class="selected-filter-chip">
                          <span>{{ selected.label }}</span>
                          <button type="button" class="selected-filter-chip-remove" (click)="removeMultiSelectValue('urgency', selected.value, $event)" aria-label="Remove {{ selected.label }} from urgency filter">
                            <i class="icon ion-close-round" aria-hidden="true"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="small-12 medium-6 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.riskLevel">
                  <label class="label-name label-top">
                    Risk
                    <span *ngIf="!filterAvailability.riskLevel" class="filter-empty-hint">(no data)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.riskLevel ? 'No strategies in this firm have this field populated' : null">
                    <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                      <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'riskLevel')">
                        <span class="multi-select-placeholder">Risk</span>
                        <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('riskLevel')">arrow_drop_down</i>
                      </div>
                      <div *ngIf="isMultiSelectOpen('riskLevel')" class="multi-select-menu">
                        <div class="multi-select-menu-title">Select one or more</div>
                        <label *ngFor="let option of riskOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                          <input type="checkbox" [checked]="isOptionSelected('riskLevel', option)"
                                 (change)="onMultiSelectOptionChange('riskLevel', option, $event)">
                          <span>{{ getOptionLabel(option) }}</span>
                        </label>
                      </div>
                      <div *ngIf="getSelectedOptions('riskLevel').length" class="selected-filter-chips">
                        <span *ngFor="let selected of getSelectedOptions('riskLevel'); trackBy: trackByFilterValue" class="selected-filter-chip">
                          <span>{{ selected.label }}</span>
                          <button type="button" class="selected-filter-chip-remove" (click)="removeMultiSelectValue('riskLevel', selected.value, $event)" aria-label="Remove {{ selected.label }} from risk level filter">
                            <i class="icon ion-close-round" aria-hidden="true"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="small-12 medium-6 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.burden">
                  <label class="label-name label-top">
                    Burden
                    <span *ngIf="!filterAvailability.burden" class="filter-empty-hint">(no data)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.burden ? 'No strategies in this firm have this field populated' : null">
                    <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                      <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'burden')">
                        <span class="multi-select-placeholder">Burden</span>
                        <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('burden')">arrow_drop_down</i>
                      </div>
                      <div *ngIf="isMultiSelectOpen('burden')" class="multi-select-menu">
                        <div class="multi-select-menu-title">Select one or more</div>
                        <label *ngFor="let option of burdenOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                          <input type="checkbox" [checked]="isOptionSelected('burden', option)"
                                 (change)="onMultiSelectOptionChange('burden', option, $event)">
                          <span>{{ getOptionLabel(option) }}</span>
                        </label>
                      </div>
                      <div *ngIf="getSelectedOptions('burden').length" class="selected-filter-chips">
                        <span *ngFor="let selected of getSelectedOptions('burden'); trackBy: trackByFilterValue" class="selected-filter-chip">
                          <span>{{ selected.label }}</span>
                          <button type="button" class="selected-filter-chip-remove" (click)="removeMultiSelectValue('burden', selected.value, $event)" aria-label="Remove {{ selected.label }} from burden filter">
                            <i class="icon ion-close-round" aria-hidden="true"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="small-12 medium-6 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.amountType">
                  <label class="label-name label-top">
                    Amount Type
                    <span *ngIf="!filterAvailability.amountType" class="filter-empty-hint">(no data)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.amountType ? 'No strategies in this firm have this field populated' : null">
                    <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                      <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'amountType')">
                        <span class="multi-select-placeholder">Amount Type</span>
                        <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('amountType')">arrow_drop_down</i>
                      </div>
                      <div *ngIf="isMultiSelectOpen('amountType')" class="multi-select-menu">
                        <div class="multi-select-menu-title">Select one or more</div>
                        <label *ngFor="let option of amountTypeOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                          <input type="checkbox" [checked]="isOptionSelected('amountType', option)"
                                 (change)="onMultiSelectOptionChange('amountType', option, $event)">
                          <span>{{ getOptionLabel(option) }}</span>
                        </label>
                      </div>
                      <div *ngIf="getSelectedOptions('amountType').length" class="selected-filter-chips">
                        <span *ngFor="let selected of getSelectedOptions('amountType'); trackBy: trackByFilterValue" class="selected-filter-chip">
                          <span>{{ selected.label }}</span>
                          <button type="button" class="selected-filter-chip-remove" (click)="removeMultiSelectValue('amountType', selected.value, $event)" aria-label="Remove {{ selected.label }} from amount type filter">
                            <i class="icon ion-close-round" aria-hidden="true"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="small-12 medium-6 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.applicableTo">
                  <label class="label-name label-top">
                    Applicable To
                    <span *ngIf="!filterAvailability.applicableTo" class="filter-empty-hint">(no data)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.applicableTo ? 'No strategies in this firm have this field populated' : null">
                    <app-tpiq-select-dropdown
                      [setData]="applicableToOptions"
                      [setPlaceHolder]="'All'"
                      [setSearchKey]="'label'"
                      [setValueKey]="'value'"
                      [setNoneLabel]="'All'"
                      [setDefaultValue]="filterModel.applicableTo"
                      [setDisabled]="!filterAvailability.applicableTo"
                      (onValueSelect)="onFilterSelect('applicableTo', 'value', $event)"></app-tpiq-select-dropdown>
                  </div>
                </div>

                <div class="small-12 medium-6 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.requiresInvestment">
                  <label class="label-name label-top">
                    Requires Investment?
                    <span *ngIf="!filterAvailability.requiresInvestment" class="filter-empty-hint">(no data)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.requiresInvestment ? 'No strategies in this firm have this field populated' : null">
                    <app-tpiq-select-dropdown
                      [setData]="requiresInvestmentOptions"
                      [setPlaceHolder]="'All'"
                      [setSearchKey]="'label'"
                      [setValueKey]="'value'"
                      [setNoneLabel]="'All'"
                      [setDefaultValue]="filterModel.requiresInvestment"
                      [setDisabled]="!filterAvailability.requiresInvestment"
                      (onValueSelect)="onFilterSelect('requiresInvestment', 'value', $event)"></app-tpiq-select-dropdown>
                  </div>
                </div>

                <div class="small-12 medium-12 columns" style="margin-bottom: 12px;"
                     [class.filter-row-disabled]="!filterAvailability.tags">
                  <label class="label-name label-top">
                    Tags
                    <span *ngIf="!filterAvailability.tags" class="filter-empty-hint">(no tags defined)</span>
                  </label>
                  <div [attr.title]="!filterAvailability.tags ? 'This firm has not defined any strategy tags yet' : null">
                    <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                      <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'tagId')">
                        <span class="multi-select-placeholder">Tags</span>
                        <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('tagId')">arrow_drop_down</i>
                      </div>
                      <div *ngIf="isMultiSelectOpen('tagId')" class="multi-select-menu">
                        <div class="multi-select-menu-title">Select one or more</div>
                        <label *ngFor="let option of tagOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                          <input type="checkbox" [checked]="isOptionSelected('tagId', option)"
                                 (change)="onMultiSelectOptionChange('tagId', option, $event)">
                          <span>{{ getOptionLabel(option) }}</span>
                        </label>
                      </div>
                      <div *ngIf="getSelectedOptions('tagId').length" class="selected-filter-chips">
                        <span *ngFor="let selected of getSelectedOptions('tagId'); trackBy: trackByFilterValue" class="selected-filter-chip">
                          <span>{{ selected.label }}</span>
                          <button type="button" class="selected-filter-chip-remove" (click)="removeMultiSelectValue('tagId', selected.value, $event)" aria-label="Remove {{ selected.label }} from tags filter">
                            <i class="icon ion-close-round" aria-hidden="true"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="small-12 medium-12 columns text-right">
                  <button type="button" (click)="clearFilters()" class="pointer"
                          style="color: #1570EF; margin-right: 15px; font-size: 14px; background: none; border: none; padding: 0; cursor: pointer;">Clear All</button>
                  <button (click)="applyFilters()" class="button small post-button" type="button">Apply</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template [ngIf]="currentTab === 'All Strategies'">
          <div class="d-flex flex-column padding-10 flex-fill min-h-0 overflow-auto core-focus-drag" cdkDropList [cdkDropListData]="allStrategiesData" (cdkDropListDropped)="drop($event)">
            <div class="strategy-info-box d-flex mt-2 mb-2" [ngClass]="{'selected-strategy' : item.selected}" cdkDrag *ngFor="let item of allStrategiesData;let i = index">
              <div class="d-flex pe-2 align-items-center">
                <img style="width: 12px;height: 15px;" src="../../../../images/core-focus/handle-icon.png"/>
              </div>
              <div class="d-flex flex-column" style="width: 100%;">
                <div class="d-flex justify-content-between move-strategy">
                  <div class="bold strategy-name mb-2">{{item.name}}</div>
                  <div class="pointer badge-tooltip move-right" (click)="moveToRight(item)">
                    <span class="topTooltiptext">Move to Right</span>
                  </div>
                </div>
                <div class="bold strategy-desc" *ngIf="item.description">
                  <div class="pointer toggle-description" (click)="toggleDescription(item)">
                      {{ item.showFullDescription ? 'View Less' : 'View More' }}
                  </div>
                  <div [innerHTML]="item.showFullDescription ? item.description : (stripHtml(item.description) | slice:0:300) + ' ...'"></div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="currentTab === 'AI Strategies'">
          <div class="d-flex flex-column padding-10 flex-fill min-h-0 overflow-auto core-focus-drag" cdkDropList [cdkDropListData]="aiStrategies" (cdkDropListDropped)="drop($event)">
            <div class="strategy-info-box d-flex mt-2 mb-2" [ngClass]="{'selected-strategy' : item.selected}" cdkDrag *ngFor="let item of aiStrategies;let i = index">
              <div class="d-flex pe-2 align-items-center">
                <img style="width: 12px;height: 15px;" src="../../../../images/core-focus/handle-icon.png"/>
              </div>
              <div class="d-flex flex-column" style="width: 100%;">
                <div class="d-flex justify-content-between move-strategy">
                  <div class="bold strategy-name mb-2">
                    {{item.name}}
                    <!-- <span class="badge-tooltip move-right ">
                      <img src="../../../../images/core-focus/information.png"/>
                      <span class=" tooltip-text">
                        <div>Why this strategy?</div>
                        {{item.suggestedInfo}}
                      </span>
                    </span> -->
                    <span *ngIf="item.suggestedInfo"
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            class="cursor-auto"
                            [attr.title]="getTooltipContent('Why this strategy?', item?.suggestedInfo)">
                        <img src="../../../../images/core-focus/information.png"/>
                      </span>
                  </div>
                  <div class="pointer badge-tooltip move-right" (click)="moveToRight(item)">
                    <span class="topTooltiptext">Move to Right</span>
                  </div>
                </div>
                <div class="bold strategy-desc" *ngIf="item.description">
                  <div class="pointer mb-2 toggle-description" (click)="toggleDescription(item)">
                      {{ item.showFullDescription ? 'View Less' : 'View More' }}
                  </div>
                  <div [innerHTML]="item.showFullDescription ? item.description : (stripHtml(item.description) | slice:0:300) + ' ...'"></div>
                </div>
                <div class="strategy-savings" *ngIf="item.planAmount !== null">
                  <div class="mt-3 mb-2 field-descriptor">
                    Est. Plan Amount
                    <span class="amount-box">{{item.planAmount | formatAmount:'$0,0'}}</span>
                    <!-- <span class="badge-tooltip move-right " *ngIf="item.fieldDescriptor">
                      <img src="../../../../images/core-focus/information.png"/>
                      <span class=" tooltip-text ">
                        <div>Amount Descriptor</div>
                        {{item.fieldDescriptor}}
                      </span>
                  </span> -->
                  <span *ngIf="item.fieldDescriptor" data-bs-toggle="tooltip" data-bs-html="true" class="cursor-auto"
                    [attr.title]="getTooltipContent('Amount Descriptor', item?.fieldDescriptor)">
                    <img src="../../../../images/core-focus/information.png" />
                  </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="strategies-list d-flex flex-column">
        <div class="bold heading header-col" style="padding: 15px !important;">Selected Tax Strategies</div>
        <div class="d-flex flex-column padding-10 flex-fill min-h-0 overflow-auto core-focus-drag"
             cdkDropList [cdkDropListData]="selectedStrategies" (cdkDropListDropped)="drop($event)">
          <div class="strategy-info-box d-flex mt-2 mb-2" [ngClass]="{'selected-strategy' : item.selected}" cdkDrag *ngFor="let item of selectedStrategies;let i = index">
            <div class="d-flex pe-2 align-items-center">
              <img style="width: 12px;height: 15px;" src="../../../../images/core-focus/handle-icon.png"/>
            </div>
            <div class="d-flex flex-column" style="width: 100%;">
              <div class="d-flex justify-content-between move-strategy">
                <div class="bold strategy-name mb-2">
                  {{item.name}}
                  <!-- <span class="badge-tooltip move-right " *ngIf="item.suggestedInfo">
                    <img src="../../../../images/core-focus/information.png"/>
                    <span class="tooltip-text  ">
                      <div>Why this strategy?</div>
                      {{item.suggestedInfo}}
                    </span>
                  </span> -->
                  <span *ngIf="item.suggestedInfo"
                            data-bs-toggle="tooltip"
                            data-bs-html="true"
                            class="cursor-auto"
                            [attr.title]="getTooltipContent('Why this strategy?', item?.suggestedInfo)">
                        <img src="../../../../images/core-focus/information.png"/>
                      </span>
                </div>
                <div class="pointer badge-tooltip move-left" (click)="moveToLeft(item)">
                  <span class="topTooltiptext">Move to Left</span>
                </div>
              </div>
              <div class="bold strategy-desc" *ngIf="item.description">
                <div class="pointer mb-2 toggle-description" (click)="toggleDescription(item)">
                      {{ item.showFullDescription ? 'View Less' : 'View More' }}
                </div>
                <div [innerHTML]="item.showFullDescription ? item.description : (stripHtml(item.description) | slice:0:300) + ' ...'"></div>
              </div>
              <div class="strategy-savings" *ngIf="item.planAmount !== null">
                <div class="mt-3 mb-2 field-descriptor">
                  Est. Plan Amount
                  <span class="amount-box">{{item.planAmount | formatAmount:'$0,0'}}</span>
                  <!-- <span class="badge-tooltip move-right " *ngIf="item.fieldDescriptor">
                    <img src="../../../../images/core-focus/information.png"/>
                    <span class=" tooltip-text">
                      <div>Amount Descriptor</div>
                      {{item.fieldDescriptor}}
                    </span>
                  </span> -->
                  <span *ngIf="item.fieldDescriptor" data-bs-toggle="tooltip" data-bs-html="true" class="cursor-auto"
                    [attr.title]="getTooltipContent('Amount Descriptor', item?.fieldDescriptor)">
                    <img src="../../../../images/core-focus/information.png" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column align-items-center justify-content-center no-strategies" *ngIf="selectedStrategies && selectedStrategies.length == 0">
            <div class="mb-2">
              <img src="../../../../images/core-focus/empty-text.png"/>
            </div>
            <div class="mt-2 text-align-center">
              <div class="text">Select Suggested Tax Strategy(ies) from the left, so you can review it in the next step.</div>
               <div class="text mt-5">Not seeing strategies you expected from the 1040? If the upload was a low-quality scan, it can be harder for RAP to read and analyze.
You can re-upload a higher-quality copy on the TaxPlanIQ dashboard (original government-filed PDF preferred), or use <strong>Report an Issue</strong> from the <strong>Hub</strong>  button (bottom-left).</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</ng-template>
